<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { ref, withDefaults } from 'vue'

const props = withDefaults(
  defineProps<{
    confirmBeforeClose?: boolean
    title: string
  }>(),
  { confirmBeforeClose: false },
)

const emit = defineEmits<{
  close: []
  requestClose: []
}>()

defineSlots<{
  default: unknown
}>()

const animationDuration = 300

const animationClass = ref('slide-in')

const onXButtonClick = (): void => {
  if (props.confirmBeforeClose) {
    emit('requestClose')
    return
  }
  animationClass.value = 'slide-out'
  setTimeout(() => {
    emit('close')
  }, animationDuration)
}
</script>

<template>
  <div
    class="fixed bottom-0 left-[66%] right-0 top-0 z-[10000] flex h-screen max-h-screen flex-col overflow-hidden bg-white shadow-lg"
    :class="[animationClass]"
    :style="`--duration: ${animationDuration}ms`"
  >
    <div class="w-full bg-lochmara-600">
      <div class="flex w-full justify-end">
        <button class="pr-4 pt-5" type="button" @click="onXButtonClick">
          <XMarkIcon class="h-6 w-6 text-white" />
        </button>
      </div>
      <h2 class="px-8 pb-11 text-center font-medium text-white">{{ title }}</h2>
    </div>
    <div class="flex-1 overflow-hidden">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slideOut {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

.slide-out {
  animation: slideOut var(--duration) ease-in-out forwards;
}

.slide-in {
  animation: slideIn var(--duration) ease-in-out forwards;
}
</style>
